import { render } from "./AlertsView.vue?vue&type=template&id=36a941ce&scoped=true"
import script from "./AlertsView.vue?vue&type=script&lang=js"
export * from "./AlertsView.vue?vue&type=script&lang=js"

import "./AlertsView.vue?vue&type=style&index=0&id=36a941ce&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36a941ce"]])

export default __exports__